import type { HttpValidationError } from '../api/intranet'

const sanitizeErrorMessage = (message: string): string => {
  return message.replaceAll(/[<>]/g, '"')
}

export const getErrorMessage = (options: {
  error: HttpValidationError
  fallbackMessage?: string
}): string | string[] => {
  const { error } = options
  const fallbackMessage = options.fallbackMessage || 'Unknown error'

  if (Array.isArray(error.detail)) {
    return error.detail.map((detail) => sanitizeErrorMessage(detail.msg))
  } else if (error.detail && typeof error.detail === 'string') {
    return sanitizeErrorMessage(error.detail)
  } else {
    return fallbackMessage
  }
}
